import { motion, useInView, useScroll, useSpring, useTransform, useMotionValue, useVelocity, useAnimationFrame } from 'framer-motion';
import { wrap } from '@motionone/utils';
import { useRef } from 'react';

export function SectionAnimation({ children, translateX }) {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    return (
        <section className='section-animation' ref={ref}>
            <span
                className='section-animation__box'
                style={{
                    transform: isInView ? 'none' : `translateX(${translateX})`,
                    opacity: isInView ? 1 : 0,
                    transition: 'all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s'
                }}
            >
                {children}
            </span>
        </section>
    );
}

export function ParallaxText({ children, baseVelocity = 100 }) {
    const baseX = useMotionValue(0);
    const { scrollY } = useScroll();
    const scrollVelocity = useVelocity(scrollY);
    const smoothVelocity = useSpring(scrollVelocity, {
        damping: 50,
        stiffness: 400
    });
    const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
        clamp: false
    });

    const x = useTransform(baseX, (v) => `${wrap(-20, -45, v)}%`);

    const directionFactor = useRef(1);
    useAnimationFrame((t, delta) => {
        let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

        if (velocityFactor.get() < 0) {
            directionFactor.current = -1;
        } else if (velocityFactor.get() > 0) {
            directionFactor.current = 1;
        }

        moveBy += directionFactor.current * moveBy * velocityFactor.get();

        baseX.set(baseX.get() + moveBy);
    });

    return (
        <div className="parallax">
            <motion.div className="parallax__scroller" style={{ x }}>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
                <span className='parallax__scroller__text'>{children} </span>
            </motion.div>
        </div>
    );
}